import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'components/ui/tooltip';
import { cn } from 'lib/utils';
import { PlanPurchaseButtonProps } from './plan-downgrade.types';

const DOWNGRADE_TOOLTIP_TEXT = 'You cannot downgrade your subscription plan manually. Please contact support to change your plan.';

export const PlanPurchaseButton = ({
  label,
  variant,
  isDisabled,
  showDowngradeTooltip,
  onSelect,
}: PlanPurchaseButtonProps) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (isDisabled) {
      return;
    }

    onSelect();
  };

  const button = (
    <Button
      className={cn(
        'w-full disabled:border-ob-border disabled:bg-transparent disabled:text-ob-text-muted disabled:opacity-100',
        showDowngradeTooltip && 'opacity-50',
      )}
      variant={variant === 'default' ? 'ob-primary' : 'ob-accent'}
      size='pill'
      onClick={handleClick}
      disabled={isDisabled && !showDowngradeTooltip}
      aria-disabled={isDisabled}
    >
      {label}
    </Button>
  );

  if (!showDowngradeTooltip) {
    return button;
  }

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className='inline-flex w-full cursor-not-allowed'>
            {button}
          </span>
        </TooltipTrigger>
        <TooltipContent className='max-w-xs text-center'>
          {t(DOWNGRADE_TOOLTIP_TEXT)}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
